/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingPayoutListConfig } from '../../config/loading.config';
import { settingsPayoutConfig } from '@/pages/PayoutPage/config/settings.config';
import { notificationsPayoutConfig } from '@/pages/PayoutPage/config/notifications.config';
import { eventTimelinePayoutListConfig } from '../../config/eventTimeline.config';
import { headerPayoutListConfig } from '../../config/header.config';
import { errorPayoutListConfig } from '../../config/error.config';
import { eventDetailPayoutListConfig } from '../../config/eventDetail.config';
import { credentialPayoutListConfig } from '../../config/credentialLists.config';
export interface IStaticPagePayoutListPluginMethods extends IPluginMethodMap {
  getStaticPagePayoutListSync(args?: any): any;
}

export class StaticPagePayoutListPlugin implements IAgentPlugin {
  readonly methods: IStaticPagePayoutListPluginMethods;

  constructor() {
    this.methods = {
      getStaticPagePayoutListSync: this.getStaticPagePayoutListSync.bind(this),
    };
  }

  getStaticPagePayoutListSync(args?: any) {
    return {
      header: headerPayoutListConfig,
      loading: loadingPayoutListConfig,
      notifications: notificationsPayoutConfig,
      settings: settingsPayoutConfig,
      error: errorPayoutListConfig,
      timeline: eventTimelinePayoutListConfig,
      credential: credentialPayoutListConfig,
      eventDetail: eventDetailPayoutListConfig,
    };
  }
}
